// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__wTjEC","language":"nav_language__KvrPw","footer":"nav_footer__88uB7"};